import * as z from "zod";

const countryCode = "US";
//const paymentMethods = ["LOCAL"];

export const EmployeeFormSchema = z.object({
  firstName: z.string({ message: "You must enter a first name" }).min(1),
  lastName: z.string({ message: "You must enter a last name" }).min(1),
  workEmail: z
    .string({ message: "You must enter a work email" })
    .min(1)
    .email("This is not a valid email"),
  departmentId: z.string({ message: "You must select a department" }).min(1),
  managerEmployeeProfileId: z.string().optional(),
  roles: z.string().array().default([]),
});

export const DepartmentFormSchema = z.object({
  name: z.string(),
});

export const CategoryFormSchema = z.object({
  uuid: z.string().optional(),
  name: z.string(),
  gl: z.string(),
  isVisible: z.boolean().default(true),
});

export const RoleSelectionSchema = z.object({
  roles: z.string().array().default([]),
});

export const BeneficiaryBankAccountFormSchema = z.object({
  beneficiary: z.object({
    address: z.object({
      city: z.string().min(1).max(50).optional(), // City is optional
      country_code: z.literal(countryCode).default(countryCode),
      postcode: z.string().min(1).max(50).optional(), // Postcode is optional
      state: z.string().min(1).max(50).optional(), // State is optional
      street_address: z.string().min(1).max(200),
    }),
    bank_details: z.object({
      account_currency: z
        .enum([
          "USD", // Adjust this list if other currencies should be supported
        ])
        .default("USD")
        .optional(),
      bank_name: z.string().min(2).max(200),
      account_name: z.string().min(2).max(200),
      account_number: z.string().regex(/^\d{1,17}$/),
      account_routing_value1: z
        .string()
        .regex(/^\d{9}$/, { message: "Routing number must be 9 digits" }),
      bank_country_code: z.literal(countryCode),
    }),
    entity_type: z.enum(["COMPANY", "PERSONAL"]).default("PERSONAL"),
    first_name: z.string().min(1).max(50),
    last_name: z.string().min(1).max(50),
    payment_methods: z.array(z.literal("LOCAL")).default(["LOCAL"]),
    personal_email: z.string().email(),
  }),
});
